export function updateSimpleData (key, value) {
  return {
    type: 'PASSIVO_UPDATE_SIMPLE_DATA',
    key,
    value
  }
}

export function updateTableExcel (el, keyNameItems, keyItem, keyData, value) {
  return {
    type: 'PASSIVO_UPDATE_TABLE_EXCEL',
    el,
    key_name_items: keyNameItems,
    key_item: keyItem,
    key_data: keyData,
    value
  }
}

export function sumTotalEl (el, keyNameItems, keyData, value) {
  return {
    type: 'PASSIVO_SUM_VALUES_FROM_ELEMENT',
    el,
    key_name_items: keyNameItems,
    key_data: keyData,
    value
  }
}

export function superSum (keyNameItems, keyItem, keyData, value) {
  return {
    type: 'PASSIVO_SUM_ALL_VALUES_BY_DATE',
    key_name_items: keyNameItems,
    key_item: keyItem,
    key_data: keyData,
    value
  }
}

export function porcentage (keyData) {
  return {
    type: 'PASSIVO_PORCENTAGE_ALL_ELEMENTS',
    key_data: keyData
  }
}

export function updateProgress (keyName) {
  return {
    type: 'PASSIVO_UPDATE_PROGRESS',
    keyName
  }
}

export function sumSubTotal (datas) {
  return {
    type: 'SUM_SUB_TOTAL_WITHOUT_VALUE',
    datas
  }
}

export function updateDate (value) {
  return {
    type: 'UPDATE_DATE',
    value
  }
}

export function exigivelTotal (keyData) {
  return {
    type: 'EXIGIVEL_TOTAL',
    key_data: keyData
  }
}

export function bootstrap (data, totalDataEl) {
  return {
    type: 'BOOTSTRAP_PASSIVO',
    data,
    total_data_el: totalDataEl
  }
}

export function totalBancos (keyData) {
  return {
    type: 'TOTAL_BANCOS',
    key_data: keyData
  }
}

export function passivoCirculante (keyData) {
  return {
    type: 'PASSIVO_CIRCULANTE',
    key_data: keyData
  }
}

export function removeDataPassivo (value, totalDates) {
  return {
    type: 'REMOVE_DATE_PASSIVO',
    value,
    total_dates: totalDates
  }
}

export function addDataPassivo () {
  return {
    type: 'ADD_NEW_DATE_PASSIVO'
  }
}

export function ativoPassivoCheck (totalAtivo, keyData) {
  return {
    type: 'ATIVO_PASSIVO_CHECK',
    total_ativo: totalAtivo,
    key_data: keyData
  }
}
